import { UtilityService } from 'app/common/services/Utility.service';
import { showPhoneNumberInString } from 'app/common/utils/common';

export class ReportAgentConst {
  static displayColumns = () => {
    return [
      {
        title: 'Chuyên viên',
        key: 'username',
        display: true,
        allowSort: false,
        classes: 'text-blue',
      },
      {
        title: 'Số lần đăng nhập',
        key: 'display_subject',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Sẵn sàng làm việc',
        key: 'display_requester',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Không sẵn sàng làm việc',
        key: 'display_assignee',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Sẵn sàng NoACD',
        key: 'display_source',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thực hiện chiến dịch',
        key: 'display_status',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Đi họp',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Đi ra ngoài',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Đào tạo',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Typing',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Ăn trưa',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static displayColumnsTicket() {
    return [
      {
        title: 'Mã Ticket',
        key: 'display_code',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chủ đề',
        key: 'display_subject',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Người yêu cầu',
        key: 'display_requester',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chuyên viên',
        key: 'display_assignee',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Nguồn',
        key: 'display_source',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Trạng thái',
        key: 'display_status',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Cập nhật lần cuối',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  }

  static displayCodeColumns = item => {
    return `<a class="text_link" href="javascript:void(0)">${item.code}</a>`;
  };
  static displaySubjectColumns = (item, user) => {
    return item.subject ? showPhoneNumberInString(item.subject, user) : 'Chưa xác định';
  };
  static displayRequesterColumns = (item, user) => {
    // return `<span class="${{item.role}}" ></span>>`;
    return item.name
      ? showPhoneNumberInString(item.name, user)
      : item.phone
        ? showPhoneNumberInString(item.phone.toString(), user)
        : item.email
          ? item.email
          : 'Chưa xác định';
  };
  static displayAssigneeColumns = (item, agents) => {
    const agent = agents.find(agent => agent.id == item.assign_agent_id);
    return agent
      ? agent.text
      : item.assignee
        ? item.assignee.name
        : item.assign_agent
          ? item.assign_agent.name
          : 'Chưa xác định';
  };
  static displaySourceColumns = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        switch (item.source_detail) {
          case 'facebook':
            return `<i class="icon fa fa-facebook"></i>`;
          case 'zalo':
            return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
          default:
            return `<i class="icon fa fa-comments"></i>`;
        }
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'sms':
        return `<i class="icon fa fa-commenting-o"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return 'Chưa xác định';
    }
  };
  static displayStatusColumns = item => {
    switch (item.status) {
      case 1:
      case '1':
        return `<span class="badge badge-danger mr-5">Mới</span`;
      case 2:
      case '2':
        return `<span class="badge badge-info mr-5">Đang xử lý</span`;
      case 3:
      case '3':
        return `<span class="badge badge-primary mr-5">Đã xử lý</span`;
      case 4:
      case '4':
        return `<span class="badge badge-danger mr-5">Mở lại</span`;
      case 5:
      case '5':
        return `<span class="badge badge-dark mr-5">Đã đóng</span`;
    }
  };
  static displayTimeColumns = time => {
    return UtilityService.dateFormat(time);
  };
}

export enum AssignType {
  All,
  MyTicket,
  InGroup,
  Follow,
  MissedCall,
  NotTag,
  Open,
  InProcess,
  Completed,
  NearExpired,
  Campaign,
}

export function getParams(data: AssignType) {
  switch (data) {
    case AssignType.MyTicket:
      return 'me';
    case AssignType.InGroup:
      return 'group';
    case AssignType.Follow:
      return 'following';
    case AssignType.Campaign:
      return 'campaign';
    default:
      return 'all';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/agent/agent.const.ts